import { ODSVisibilityOff, ODSVisibilityOn } from '@telekom-ods/react-icons';
import { ODSTextField } from '@telekom-ods/react-ui-kit';
import { useState, type FC, type ChangeEvent, type FocusEvent } from 'react';

interface ODSPasswordFieldProps {
  id?: string;
  name: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  helperText?: string;
  size?: 'small' | 'large';
}

export const ODSPasswordField: FC<ODSPasswordFieldProps> = ({
  id = '',
  name,
  value = '',
  onChange,
  onBlur,
  label,
  placeholder = '',
  disabled = false,
  helperText = '',
  size = 'small',
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = (): void => {
    setShowPassword(!showPassword);
  };
  const visibilityIcon = showPassword ? <ODSVisibilityOn /> : <ODSVisibilityOff />;
  return (
    <ODSTextField
      inputProps={{
        id: id || name,
        type: showPassword ? 'text' : 'password',
        name: name,
        onChange,
        onBlur,
      }}
      placeholderText={placeholder}
      supportMessageProps={{
        helperText: helperText,
        'data-testid': `${name}-helper`,
      }}
      value={value}
      labelText={label}
      disabled={disabled}
      size={size}
      mode={helperText ? 'error' : 'informative'}
      textFieldIconProps={{
        buttonProps: {
          buttonIcon: visibilityIcon,
          'data-testid': 'visibility-button',
        },
        icon: visibilityIcon,
        type: 'buttonContainer',
        onClick: handleClickShowPassword,
      }}
      showRightIcon={true}
      style={{ marginBottom: '1rem' }}
    />
  );
};
